import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpButtonModule, FcpIconModuleSVG } from 'fc-ui-components';
import { SignupVerifiedEmailComponent } from './verified-email.component';

@NgModule({
    imports: [CommonModule, TranslateModule, FcpButtonModule, FcpIconModuleSVG],
    declarations: [SignupVerifiedEmailComponent],
    exports: [SignupVerifiedEmailComponent]
})
export class SignupVerifiedEmailModule {}
